import { Navigate, useParams } from 'react-router-dom';

/**
 * Safety net for the shareable invitation link (`/i/:token`).
 *
 * That path is normally answered by the API (CloudFront routes `/i/*` to the
 * origin) with a server-rendered page carrying the event's Open Graph tags —
 * that page is what chat apps read, and it redirects humans to `/rsvp/:token`.
 * If the request ever reaches the SPA instead — the behavior not deployed yet,
 * or an in-app browser replaying a cached shell — the guest must still land on
 * their invitation rather than a "page not found".
 */
export function InviteShareRedirect() {
  const { token } = useParams<{ token: string }>();
  return <Navigate to={token ? `/rsvp/${token}` : '/'} replace />;
}
